var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyboardDoubleArrowLeft = function SvgKeyboardDoubleArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.126 17.654 5.473 12l5.653-5.653L12.18 7.4 7.596 12l4.584 4.6zm6.35 0L11.823 12l5.653-5.653L18.53 7.4 13.946 12l4.584 4.6z"
  })));
};
export default SvgKeyboardDoubleArrowLeft;